var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLowPowerModeIcon = function SvgLowPowerModeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9488_17419)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6849 9.64583L10.6757 16.8817C10.2165 17.5442 9.17736 17.22 9.17736 16.4133V11.6442H4.98986C4.32653 11.6442 3.93569 10.8992 4.31403 10.3533L9.32319 3.1175C9.78236 2.455 10.8215 2.77917 10.8215 3.58583V8.355H15.009C15.6715 8.355 16.0624 9.1 15.6849 9.64583Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5383,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9488_17419"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgLowPowerModeIcon as ReactComponent };
export default __webpack_public_path__ + "low-power-mode-icon.svg";